// extracted by mini-css-extract-plugin
export default {"characteristics":"CharacterProfileTypes_characteristics__me+Sz","overviewStatus":"CharacterProfileTypes_overviewStatus__l94D4","overview":"CharacterProfileTypes_overview__vCvZm"};